export const educationData = [
    {
        id: 1,
        institution: 'Pakundia Pilot Adarsha High School',
        course: 'Secondary School Certificate',
        startYear: '2012',
        endYear: '2014'
    },
    {
        id: 2,
        institution: 'Vashantek Government College',
        course: 'Higher Secondary Certificate',
        startYear: '2014',
        endYear: '2016'
    },
    {
        id: 3,
        institution: 'Daffodil International University, Bangladesh',
        course: 'Computer Science and Engineering',
        startYear: '2018',
        endYear: 'Present'
    },
]